module.exports = __webpack_public_path__ + "img/energy-behaviors-banner.d38e899a.png";